(function(){
	'use strict';
	angular.module('app.setup')
		.controller('userFactory', userFactory);

	userFactory.$inject = ['$scope', '$timeout', '$uibModal', '$rootScope', '$location',
		'tableService', 'leanFilterService', 'userManagementService', 'tableRenderService', 'userFactoryTableRenderService', 'siteService', '$experiments', '$translate'];

	function userFactory($scope, $timeout, $uibModal, $rootScope, $location, 
			tableService, leanFilterService, userManagementService, tableRenderService, userFactoryTableRenderService, siteService, $experiments, $translate) {
		var vm = this;
		var rendererParams = {};
		var reportSettingsName = 'userFactory';
		var reportSettingsId;
		var yesNoList = [{'display': 'Yes', 'value': true}, {'display': 'No', 'value': false}];
		var metricEntryList = [{'display': 'Assigned', 'value': false}, {'display': 'All', 'value': true}];
		var metricTargetEntryList = [{'display': 'None', 'value': false}, {'display': 'All', 'value': true}];
		var emailList = [{'display': 'Daily'}, {'display': 'Immediate'}, {'display': 'Off'}];
		var extraParams = [{}];
		var noPaging = true;
		var defaultFilters = [{}];
		var columns = [];
		var userLastModified;

		vm.userObj = {};
		vm.customer = {};
		vm.noneSelected = true;
		vm.customersSelected = false;
		vm.myAccountView = $location.path() && $location.path() === '/account/edit';
		vm.isCustomerAdmin = $rootScope.authz.isCustomerAdmin();
		vm.isSuperAdmin = $rootScope.authz.isSuperAdmin();
		vm.isSuperOrCustomerAdmin = vm.isCustomerAdmin || vm.isSuperAdmin;
		vm.isSupplier = globalConfig.user.role == 'Supplier';
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.displayHideFromDropdown = globalConfig.user.userName.indexOf('leandna.com') > -1;
		vm.userNdx = globalConfig.user.id;
		vm.isLoadingUserData = true;
		vm.lists = {
			'authorizeLeanInitiativeFlag': yesNoList,
			'isFinancialApprover': yesNoList,
			'isSmeCertified': yesNoList,
			'isWorkbenchSupervisor': yesNoList,
			'canEditAnyMetric': metricEntryList,
			'canEditAnyMetricTargets': metricTargetEntryList,
			'emailType': emailList,
			'invalidateInventoryActions': yesNoList,
			'hideFromUserDropdown': yesNoList,
			'isCustomerAdministrator': yesNoList,
			'canCreateSupplierUser': yesNoList,
			'isLeanOnly': yesNoList
		};
		vm.urlMap = {
			'profileType': userManagementService.getProfileTypes,
			'roleType': userManagementService.getRoles,
			'supplierNdx': userManagementService.getSuppliers
		};
		vm.variableLabel = {
			'profileType': 'Privileges',
			'authorizeLeanInitiativeFlag': 'Approve Lean Projects',
			'isFinancialApprover': 'Approve Lean Projects Savings',
			'isSmeCertified': 'SME Certified',
			'isWorkbenchSupervisor': 'Workbench Supervisor',
			'emailType': 'Lean Project Emails',
			'roleType': 'Role',
			'canCreateSupplierUser': 'Can create supplier user',
			'supplierNdx': 'Supplier',
			'canEditAnyMetric': 'Metric Entry',
			'canEditAnyMetricTargets': 'Metric Target Entry',
			'invalidateInventoryActions': 'Invalidate Inventory Actions',
			'hideFromUserDropdown': 'Hide from User Dropdowns',
			'isLeanOnly': 'Limit to lean projects'
		};
		vm.showEditSupplier = false;
		vm.manageSupplierSites = manageSupplierSites;
		vm.closeManageSupplierSites = closeManageSupplierSites;

		$scope.$on('updateNoneSelected', function(event, args) {
			vm.noneSelected = args.noneSelected;
		});

		$scope.$on('updateCustomersSelected', function (event, args) {
			vm.customersSelected = args.customersSelected;
		});

		$scope.$on('reloadUser', function(event, args) {
			loadUser();
		});

		function setUrl() {
			var showRollupRows =  ($scope.customer.isCustomerAdministrator && vm.isCustomerAdmin) || vm.isSuperAdmin;
			var url = 'User/' + vm.userNdx + '/AllFactories?showInactive=true&hideRollupRows=' + !showRollupRows;
			return url;
		}
		
		columns.push({
			'id': 'isChecked',
			'display': '$checkbox',
			'renderer': userFactoryTableRenderService.checkboxRenderer,
			'sort': false,
			'hideMenu': true,
			'width': 45,
			'disabledShowHide': true
		});
		columns.push({
			'id': 'customerName',
			'display': 'Company Name',
			'class': '',
			'sort': false,
			'renderer': userFactoryTableRenderService.customerNameRenderer,
			'disabledShowHide': true
		});
		columns.push({
			'id': 'alias',
			'display': 'Site',
			'sort': false,
			'renderer': userFactoryTableRenderService.factoryNameRenderer,
			'disabledShowHide': true
		});
		if (vm.isAdmin) {
			columns.push({
				'id': 'profileType',
				'display': 'Privileges',
				'renderer': userFactoryTableRenderService.profileTypeRenderer,
				'sort': false,
				'disabled': true,
				'disabledShowHide': true
			});
			columns.push({
				'id': 'permissionName',
				'display': 'Permissions',
				'renderer': userFactoryTableRenderService.readOnlyTextRenderer,
				'sort': false,
				'disabled': true,
				'disabledShowHide': true
			});
			columns.push({
				'id': 'mandatoryFilterNames',
				'display': 'Mandatory Filters',
				'renderer': userFactoryTableRenderService.readOnlyTextRenderer,
				'sort': false,
				'disabled': true,
				'disabledShowHide': true
			});
		}
		columns.push({
			'id': 'roleType',
			'display': 'Role',
			'renderer': userFactoryTableRenderService.roleRenderer,
			'sort': false,
			'disabledShowHide': true
		});
		columns.push({
			id: 'canCreateSupplierUser',
			display: 'Can create supplier user',
			renderer: userFactoryTableRenderService.canCreateSupplierUserRenderer,
			sort: false,
			disabled: false,
			disabledShowHide: true
		});
		if (vm.isAdmin) {
			columns.push({
				'id': 'supplierNdx',
				'display': 'Supplier',
				'renderer': userFactoryTableRenderService.supplierRenderer,
				'sort': false,
				'disabled': true,
				'disabledShowHide': true
			});
		}
		columns.push({
			'id': 'isSmeCertified',
			'display': 'SME Certified',
			'renderer': userFactoryTableRenderService.yesNoRenderer,
			'allowUser': false,
			'internalAdminsOnly': true,
			'disabled': false,
			'sort': false,
			'disabledShowHide': true
		});
		columns.push({
			'id': 'isWorkbenchSupervisor',
			'display': 'Workbench Supervisor',
			'renderer': userFactoryTableRenderService.yesNoRenderer,
			'allowUser': false,
			'disabled': false,
			'sort': false,
			'disabledShowHide': true
		});
		if (vm.isAdmin) {
			columns.push({
				'id': 'authorizeLeanInitiativeFlag',
				'display': 'Approve Lean Projects',
				'renderer': userFactoryTableRenderService.adminYesNoRenderer,
				'allowUser': false,
				'disabled': true,
				'sort': false,
				'disabledShowHide': true
			});

			columns.push({
				'id': 'isFinancialApprover',
				'display': 'Approve Lean Projects Savings',
				'renderer': userFactoryTableRenderService.yesNoRenderer,
				'allowUser': false,
				'disabled': true,
				'sort': false,
				'disabledShowHide': true
			});
			columns.push({
				'id': 'canEditAnyMetric',
				'display': 'Metric Entry',
				'renderer': userFactoryTableRenderService.metricEntryRenderer,
				'sort': false,
				'allowUser': false,
				'disabled': true,
				'disabledShowHide': true
			});
			columns.push({
				'id': 'canEditAnyMetricTargets',
				'display': 'Metric Target Entry',
				'renderer': userFactoryTableRenderService.metricEntryRenderer,
				'allowUser': false,
				'isTarget': true,
				'disabled': true,
				'sort': false,
				'disabledShowHide': true
			});
		}
		columns.push({
			'id': 'emailType',
			'display': 'Lean Project Emails',
			'renderer': userFactoryTableRenderService.emailFreqRenderer,
			'sort': false,
			'disabledShowHide': true
		});
		columns.push({
			'id': 'invalidateInventoryActions',
			'display': 'Invalidate Inventory Actions',
			'renderer': userFactoryTableRenderService.yesNoRenderer,
			'sort': false,
			'disabled': true,
			'disabledShowHide': true
		});
		if (vm.displayHideFromDropdown) {
			columns.push({
				id: 'hideFromUserDropdown',
				display: 'Hide from User Dropdowns',
				renderer: userFactoryTableRenderService.yesNoRenderer,
				sort: false,
				'disabledShowHide': true
			});
		}
		if (!vm.isSupplier) {
			columns.push({
				id: 'isLeanOnly',
				display: 'Limit to lean projects',
				renderer: userFactoryTableRenderService.isLeanOnlyRenderer,
				sort: false,
				'disabledShowHide': true
			});
		}

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportUrl: setUrl(),
			noPaging: noPaging,
			columns: columns,
			pinnedColumns: [],
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			hideFiltersContainer: true,
			hideNoResultsSuggestion: true,
			hasTabs: true,
			setColumnDefaults: true,
			noFactory: true,
			footer: false,
			isGlobalReportSetting:true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.currentlyNoneSelected = currentlyNoneSelected;
		vm.currentlyCustomersSelected = currentlyCustomersSelected;
		vm.addFactoryModal = addFactoryModal;
		vm.addCustomerModal = addCustomerModal;
		vm.deleteSelected = deleteSelected;
		vm.changeActivation = changeActivation;
		vm.downgradeCompanyAdmin = downgradeCompanyAdmin;
	
		function getMeta() {
			return meta;
		}

		function getFactRollupValue(facts, field) {
			var count = facts.reduce(function(acc, fact) {
				return acc + fact[field];
			}, 0);
			// used for display inside yesNoRenderer for rollup rows
			// 1 for all yes,
			// 0 for all no,
			// -1 for all mixed
			if (count === facts.length) {
				return 1;
			} else if (count > 0){
				return -1;
			}
			return 0;
		}

		function getData(params, extraParams) {
			vm.isLoadingUserData = true;
			loadUser();
			var url = setUrl();
			params.url = url;
			return tableService.getData(params, extraParams).then(function (response) {
				response[0].data.forEach(function(row) {
					if (row.isRollup === 1) {
						var facts = response[0].data.filter(function(r) { return r.isRollup === 0 && r.customerNdx === row.customerNdx; });
						if (facts.length > 0) {
							angular.forEach(_.keys(userFactoryTableRenderService.factRollupFields), function(field) {
								row[userFactoryTableRenderService.factRollupFields[field]] = getFactRollupValue(facts, field);
							});
						}
					} 
				});
				return response;
			});
		}

		function loadUser() {
			userManagementService.loadUser(vm.userNdx).then(function (response) {
				if (response && response.status && response.status === 404) {
					location.href = '/application/f/home.html#/setup/manage-users';
				}
				if (response && response.data) {
					var headers = response.headers();
					if (headers) {
						userLastModified = headers['last-modified'];
					}
					$scope.user = response.data.base;
					$scope.customer = response.data.customer;
					vm.userObj = _.clone($scope.user);
					if ($scope.customer === null) {
						$scope.customer = { 'isCustomerAdministrator': $scope.user.isSuperSystemAdministrator };
					}
					vm.customer = _.clone($scope.customer);
				}
				vm.isLoadingUserData = false;
			});
		}

		init();

		function init() {
			var incomingQParam = $location.search();
			if (incomingQParam && incomingQParam.userNdx) {
				vm.userNdx = incomingQParam.userNdx;
				vm.myAccountView = vm.myAccountView || (vm.userNdx == globalConfig.user.id && !vm.isSuperOrCustomerAdmin);
			}
			rendererParams['userNdx'] = vm.userNdx;
			angular.forEach(columns, function (column) {
				if (!$scope.user.isSuperSystemAdministrator) {
					column['disabled'] = false;
				}
				if (column.id === 'customerName' && (($scope.customer.isCustomerAdministrator && vm.isCustomerAdmin) || vm.isSuperAdmin)) {
					column['class'] = 'expander';
				}
				if (column.id === 'supplierNdx' && $scope.customer.roleType !== 'Supplier' && !vm.isSuperAdmin) {
					column['disabled'] = true;
				}
				if (column.id === 'isChecked' && vm.myAccountView) {
					column['disabled'] = true;
				}
			});
			leanFilterService.clearFilters();
			leanFilterService.setMasterFilterList([]);
		}

		function currentlyNoneSelected() {
			return vm.noneSelected;
		};

		function currentlyCustomersSelected() {
			return vm.customersSelected;
		}

		function addCustomerModal() {
			vm.hasMultipleCustomers = siteService.getCustomersCount() > 1;
			var addCustomerScope = $scope.$new();
			addCustomerScope.displayHideFromDropdown = vm.displayHideFromDropdown;
			addCustomerScope.selected = {};
			addCustomerScope.selected.customers = [];
			addCustomerScope.isSuperSystemAdministrator = vm.userObj.isSuperSystemAdministrator;
			addCustomerScope.singleCustomer = false;
			//SET DEFAULTS
			addCustomerScope.selected.homePage = {
				forSupplier: false,
				isActive: true,
				name: 'Dashboard',
				uri: 'f/home.html#/'
			};
			addCustomerScope.selected.emailType = {
				'display': 'Daily'
			};

			addCustomerScope.selected.hideFromUserDropdown = {
				'display': vm.userObj.emailAddress.indexOf('@leandna.com') === -1 || !vm.displayHideFromDropdown ? 'No' : 'Yes',
				'value': vm.userObj.emailAddress.indexOf('@leandna.com') === -1 || !vm.displayHideFromDropdown ? false : true
			};
			
			addCustomerScope.selected.isCustomerAdministrator = {
				'display': 'Yes',
				'value': true
			};

			var dropdownLists = _.clone(vm.lists);

			userManagementService.getUnassignedFactories(vm.userNdx, true)
				.then(function (data) {
					dropdownLists.unassignedCustomers = data;
					if (!data || !data.length) {
						$rootScope.$emit('toast', {
							'message': 'No customers available to add',
							'success': false
						});
						return;
					} else {
						if (data.length == 1) {
							addCustomerScope.selected.customers.push(data[0]);
							addCustomerScope.singleCustomer = true;
						}
						openModal();
					}
				});

			var instance;

			function openModal() {
				if (!vm.lists.roleType) {
					vm.urlMap.roleType().then(function (data) {
						data = _.filter(data, function (o) {
							return o.roleType !== 'Supplier';
						});
						dropdownLists.roleType = data;
					});
				}

				instance = $uibModal.open(opts);
			}

			addCustomerScope.lists = dropdownLists;
			addCustomerScope.add = function () {
				addCustomersToUser();
			};

			var opts = {
				scope: addCustomerScope,
				templateUrl: '/application/f/setup/add_customer_to_user.html'
			};

			addCustomerScope.closeDialog = function () {
				instance.close();
				addCustomerScope.$destroy();
			};

			function addCustomersToUser() {
				// build list of user customer objects
				var list = [];
				var ndxList = [];
				angular.forEach(addCustomerScope.selected.customers, function (cust) {
					var obj = {};
					obj.customerNdx = cust.customerNdx;
					ndxList.push(cust.customerNdx);
					obj.emailType = addCustomerScope.selected.emailType.display;
					obj.homePage = addCustomerScope.selected.homePage.uri;
					obj.profileType = addCustomerScope.isSuperSystemAdministrator ? 'SuperSystemAdministrator' : 'SystemAdministrator';
					obj.roleType = addCustomerScope.selected.roleType.roleType;
					obj.hideFromUserDropdown = addCustomerScope.selected.hideFromUserDropdown.value;
					obj.isCustomerAdministrator = addCustomerScope.selected.isCustomerAdministrator.value;
					obj.canCreateSupplierUser = false;
					obj.canAccessIOP = false;
					obj.canAccessKei = false;
					list.push(obj);
				});
				if (list && list.length) {
					userManagementService.addFactoriesToUser(vm.userNdx, ndxList.toString(), list, true)
						.then(function (response) {
							if (response && response.status && response.status >= 200 && response.status < 400) {
								$rootScope.$emit('toast', {
									'message': 'Sites have been added successfully',
									'success': true
								});
								$scope.$broadcast('reloadTable');
								location.reload();
							} else {
								$rootScope.$emit('toast', {
									'message': 'Unexpected server error',
									'success': false
								});
							}
						});
				}
				instance.close();
				addCustomerScope.$destroy();
			};
		};

		function addFactoryModal() {
			vm.hasMultipleCustomers = siteService.getCustomersCount() > 1;
			var addFactoryScope = $scope.$new();
			addFactoryScope.displayHideFromDropdown = vm.displayHideFromDropdown;
			addFactoryScope.selected = {};
			addFactoryScope.selected.factories = [];
			addFactoryScope.isSuperSystemAdministrator = vm.userObj.isSuperSystemAdministrator;
			addFactoryScope.customerNdx = vm.customer.customerNdx;
			addFactoryScope.customerName = $rootScope.displayTabs.customerName;
			addFactoryScope.hasCustomerProfile = vm.customer.customerNdx > 0;
			//SET DEFAULTS
			addFactoryScope.selected.profileType = {
				profileType: addFactoryScope.isSuperSystemAdministrator ? 'SuperSystemAdministrator' : 'ReadWriteUser',
				profileTypeDisplay: addFactoryScope.isSuperSystemAdministrator ? 'Super Administrator' : 'User'
			};
			if (vm.customer.roleType) {
				addFactoryScope.selected.roleType = {
					'roleType': vm.customer.roleType,
					'name': vm.customer.roleTypeDisplay
				};
			}
			addFactoryScope.selected.homePage = vm.customer.homePage ? 
				{
					'forSupplier': vm.customer.roleType == 'Supplier',
					'isActive': true,
					'name': 'Dashboard',
					'uri': 'f/home.html#/'				
				}	: {
					'forSupplier': false,
					'isActive': true,
					'name': 'Dashboard',
					'uri': 'f/home.html#/'
				};
			addFactoryScope.selected.authorizeLeanInitiativeFlag = {
				'display': 'No',
				'value': false
			};
			addFactoryScope.selected.canEditAnyMetric = false;
			addFactoryScope.selected.canEditAnyMetricTargets = false;
			addFactoryScope.selected.emailType = {
				'display': 'Daily'
			};
			addFactoryScope.selected.isFinancialApprover = {
				'display': 'No',
				'value': false
			};
			addFactoryScope.selected.isSmeCertified = {
				'display': 'No',
				'value': false
			};
			addFactoryScope.selected.isWorkbenchSupervisor = {
				'display': 'No',
				'value': false
			};
			addFactoryScope.selected.invalidateInventoryActions = {
				'display': 'No',
				'value': false
			};
			
			addFactoryScope.selected.hideFromUserDropdown = {
				'display': vm.userObj.emailAddress.indexOf('@leandna.com') === -1 || !vm.displayHideFromDropdown ? 'No': 'Yes',
				'value': vm.userObj.emailAddress.indexOf('@leandna.com') === -1 || !vm.displayHideFromDropdown ? false : true
			};
			var dropdownLists = _.clone(vm.lists);
			userManagementService.getUnassignedFactories(vm.userNdx)
				.then(function (data) {
					dropdownLists.unassignedFactories = data;
					if (!data || !data.length) {
						$rootScope.$emit('toast', {
							'message': $translate.instant('No sites available to add for company {{customerName}}', {customerName: addFactoryScope.customerName}),
							'success': false
						});
						return;
					} else {
						openModal();
					}
				});
			
			var instance;

			function openModal() {
				if (!vm.lists.profileType) {
					vm.urlMap.profileType().then(function (data) {
						dropdownLists.profileType = data;
					});
				}

				if (!vm.lists.roleType) {
					vm.urlMap.roleType().then(function (data) {
						if (addFactoryScope.isSuperSystemAdministrator) {
							data = _.filter(data, function (o) {
								return o.roleType !== 'Supplier';
							});
						}
						dropdownLists.roleType = data;
					});
				}

				instance = $uibModal.open(opts);
			}

			addFactoryScope.lists = dropdownLists;

			// add supplier list
			addFactoryScope.updateDependentDropdowns = function() {
				if (addFactoryScope.selected.roleType && addFactoryScope.selected.roleType.roleType === 'Supplier') {
					addFactoryScope.lists.supplier = null;
					addFactoryScope.selected.supplier = null;
					if (addFactoryScope.selected.factories) {
						addFactoryScope.loadSuppliers();
					}
				}

			};

			addFactoryScope.loadSuppliers = function () {
				var factories = addFactoryScope.selected.factories;
				var factoryNdxs = [];
				for (var i = 0; i < factories.length; i++) {
					factoryNdxs.push(factories[i].ndx);
				}
				userManagementService.getCrossSiteSuppliers(factoryNdxs)
					.then(function (data) {
						var rawData = data;
						var supplierList = [];
						for (var i = 0; i < rawData.length; i++) {
							var rawEntry = rawData[i];
							var formattedEntry = {};
							formattedEntry.supplierName = rawEntry.name;
							formattedEntry.supplierCode = rawEntry.supplierCode;
							formattedEntry.supplierNdxs = rawEntry.ndxs;
							formattedEntry.factoryNdxs = rawEntry.factoryNdxs;
							supplierList.push(formattedEntry);
						}

						addFactoryScope.lists.supplier = supplierList;
					});
			};

			addFactoryScope.$watch('selected.roleType', function () {
				if (addFactoryScope.selected.roleType && addFactoryScope.selected.roleType.roleType === 'Supplier') {
					//Change values if needed
					addFactoryScope.selected.profileType = {
						profileType: 'ReadWriteUser',
						profileTypeDisplay: 'User'
					};
					addFactoryScope.selected.authorizeLeanInitiativeFlag = {
						'display': 'No',
						'value': false
					};
					addFactoryScope.selected.isFinancialApprover = {
						'display': 'No',
						'value': false
					};
					addFactoryScope.selected.canEditAnyMetric = false;
					addFactoryScope.selected.canEditAnyMetricTargets = false;
				}
			});

			addFactoryScope.$watch('selected.profileType', function () {
				if (addFactoryScope.selected.profileType && 
					(addFactoryScope.selected.profileType.profileType === 'SystemAdministrator' || 
					 addFactoryScope.selected.profileType.profileType === 'SuperSystemAdministrator')) {

					addFactoryScope.selected.authorizeLeanInitiativeFlag = {
						'display': 'Yes',
						'value': true
					};
				}
			});

			addFactoryScope.isApproveLeanProjectsDisabled = function () {
				return addFactoryScope.selected.profileType && 
					(addFactoryScope.selected.profileType.profileType === 'SystemAdministrator' || 
					 addFactoryScope.selected.profileType.profileType === 'SuperSystemAdministrator');
			};

			addFactoryScope.add = function () {
				if(validateEmailSufixes(addFactoryScope.selected.factories)) {
					addSitesToUser();
				}
			};

			var opts = {
				scope: addFactoryScope,
				templateUrl: '/application/f/setup/add_factory_to_user.html'
			};

			addFactoryScope.closeDialog = function () {
				instance.close();
				addFactoryScope.$destroy();
			};

			function addSitesToUser() {
				// build list of user factory objects
				var list = [];
				var ndxList = [];
				angular.forEach(addFactoryScope.selected.factories, function (fact) {
					var obj = {};
					obj.leanDirFactoryNdx = fact.ndx;
					ndxList.push(fact.ndx);
					obj.authorizeLeanInitiativeFlag = addFactoryScope.selected.authorizeLeanInitiativeFlag.value;
					obj.emailType = addFactoryScope.selected.emailType.display;
					obj.canEditAnyMetric = addFactoryScope.selected.canEditAnyMetric;
					obj.canEditAnyMetricTargets = addFactoryScope.selected.canEditAnyMetricTargets;
					obj.isFinancialApprover = addFactoryScope.selected.isFinancialApprover.value;
					obj.isSmeCertified = addFactoryScope.selected.isSmeCertified.value;
					obj.isWorkbenchSupervisor = addFactoryScope.selected.isWorkbenchSupervisor.value;
					obj.homePage = addFactoryScope.selected.homePage.uri;
					obj.profileType = addFactoryScope.selected.profileType.profileType;
					obj.roleType = addFactoryScope.selected.roleType.roleType;
					obj.invalidateInventoryActions = addFactoryScope.selected.invalidateInventoryActions.value;
					obj.hideFromUserDropdown = addFactoryScope.selected.hideFromUserDropdown.value;
					obj.isVirtualProfile = false;
					if (addFactoryScope.selected.supplier) {
						var supplierNdxListString = addFactoryScope.selected.supplier.supplierNdxs;
						var factoryNdxListString = addFactoryScope.selected.supplier.factoryNdxs;
						var supplierNdxList = supplierNdxListString.split(',');
						var factoryNdxList = factoryNdxListString.split(',');
						var index = factoryNdxList.indexOf(fact.ndx.toString());
						if (index > -1) {
							obj.supplierNdx = supplierNdxList[index];
							obj.supplierCode = addFactoryScope.selected.supplier.supplierCode;
						}
					} else {
						obj.supplierNdx = '';
					}
					list.push(obj);
				});
				if (list && list.length) {
					userManagementService.addFactoriesToUser(vm.userNdx, ndxList.toString(), list)
						.then(function (response) {
							if (response && response.status && response.status >= 200 && response.status < 400) {
								$rootScope.$emit('toast', {
									'message': 'Sites have been added successfully',
									'success': true
								});
								$scope.$broadcast('reloadTable');
							} else {
								$rootScope.$emit('toast', {
									'message': 'Unexpected server error',
									'success': false
								});
							}
						});
				}

				instance.close();
				addFactoryScope.$destroy();
			}

			function validateEmailSufixes(factories) {
				if (vm.isAdmin && vm.hasMultipleCustomers) {
					var customersNeedingVerification = {};
					angular.forEach(factories, function (fact) {
						if (fact['emailSuffix'] &&
							!vm.userObj.emailAddress.toLowerCase().endsWith(fact['emailSuffix'].toLowerCase()) && 
							!vm.userObj.emailAddress.toLowerCase().endsWith('leandna.com')) {
							customersNeedingVerification[fact.customerName] = { userEnteredName: undefined };
						}
					});
					if(Object.keys(customersNeedingVerification).length > 0) {
						emailSuffixConfirmationForm(customersNeedingVerification, vm.userObj.emailAddress);
						return false;
					} else {
						return true;
					}
				} else {
					return true;
				}
			}

			function emailSuffixConfirmationForm(customersNeedingVerification, emailAddress) {
				var emailSuffixConfirmationScope = $scope.$new();
				emailSuffixConfirmationScope.customersNeedingVerification = customersNeedingVerification;
				emailSuffixConfirmationScope.userEmailAddress = emailAddress;
				emailSuffixConfirmationScope.preventPaste = function (ev) {
					ev.preventDefault();
				}; 
				emailSuffixConfirmationScope.submitSuffixForm = function () {
					var hasErrors = false;
					for (var key in emailSuffixConfirmationScope.customersNeedingVerification) {
						if (key.toLowerCase() !== emailSuffixConfirmationScope.customersNeedingVerification[key].userEnteredName.toLowerCase()) {
							hasErrors = true;
						}
					}

					if (hasErrors) {
						$rootScope.$emit('toast', {
							'message': 'Please enter correct customer name in each box.',
							'success': false
						});
					} else {
						emailSuffixInstance.close();
						emailSuffixConfirmationScope.$destroy();
						addSitesToUser();
					}
				};

				var opts = {
					scope: emailSuffixConfirmationScope,
					templateUrl: '/application/f/setup/multi_site_email_suffix_confirmation.html'
				};

				var emailSuffixInstance = $uibModal.open(opts);
				emailSuffixConfirmationScope.closeDialog = function () {
					emailSuffixInstance.close();
					emailSuffixConfirmationScope.$destroy();
					instance.close();
					addFactoryScope.$destroy();
				};
			}
		};

		function changeActivation(activation) {
			$scope.$broadcast('changeFactoryActivation', { userNdx: vm.userNdx,  activation: activation});
		};

		function deleteSelected() {
			$scope.$broadcast('deleteSelectedFactories', { userNdx: vm.userNdx});
		};

		function downgradeCompanyAdmin() {
			$scope.$broadcast('downgradeCompanyAdmin', { userNdx: vm.userNdx });
		}	

		function manageSupplierSites() { 
			vm.showEditSupplier = true;
		}

		function closeManageSupplierSites(reload, goToManageUsers) { 
			$timeout(function () {
				vm.showEditSupplier = false;
			}, 0);
			
			if (reload) {
				$scope.$broadcast('reloadTable');
			}
			if (goToManageUsers) {
				location.href = '/application/f/home.html#/setup/manage-users';
			}
		}
	};
})();
